import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {collectQueryParams} from '../../utils/queryParams';
import {useState} from 'react';
import {ImposedImageService} from './ImposedImage.service';

type Props = {
  img: string;
  interestImageMap: Record<string, string>;
  interestTitleMap: Record<string, string>;
  maxWidth?: string;
};

const ImposedImage = ({
  img,
  maxWidth,
  interestImageMap,
  interestTitleMap,
}: Props) => {
  const [imgLoaded, setImageLoaded] = useState(false);
  const childNameParam = collectQueryParams()['childName'];
  const isLongName = childNameParam?.length > 7;

  const textShadowColor = 'rgba(0, 0, 0, 0.8)';
  const interestImage = ImposedImageService.getImage(interestImageMap);
  const interestTitle = ImposedImageService.getTitle(interestTitleMap);
  const bookTitle = interestTitle || `${childNameParam || ''} the Dino`;
  const xsmallFontSize = ImposedImageService.calculateFontSize(
    bookTitle,
    150,
    16,
    5,
  );
  const smallFontSize = ImposedImageService.calculateFontSize(
    bookTitle,
    300,
    32,
    12,
  );
  const largeFontSize = ImposedImageService.calculateFontSize(
    bookTitle,
    400,
    40,
    16,
  );

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <Box
        sx={{
          position: 'relative',
          width: maxWidth || '700px',
          aspectRatio: '3 / 2',
          backgroundRepeat: 'no-repeat',
          overflow: 'hidden',
          backgroundImage: `url(${interestImage || img})`,
          backgroundSize: 'contain',
          backgroundPosition: 'center',
        }}>
        {/* Add hidden img tag to trigger onLoad */}
        <img
          src={img}
          alt="Imposed"
          style={{display: 'none'}}
          onLoad={() => setImageLoaded(true)}
        />

        {imgLoaded && (
          <Typography
            sx={{
              width: '100%',
              position: 'absolute',
              top: isLongName ? '85%' : '90%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              fontSize: {
                xs: xsmallFontSize,
                sm: smallFontSize,
                md: largeFontSize,
              },
              fontWeight: 'bold',
              color: '#FFFFFF',
              textShadow: {
                xs: `-1px -1px 0 ${textShadowColor}, 1px -1px 0 ${textShadowColor}, -1px 1px 0 ${textShadowColor}, 1px 1px 0 ${textShadowColor}`,
                sm: `-2px -2px 0 ${textShadowColor}, 2px -2px 0 ${textShadowColor}, -2px 2px 0 ${textShadowColor}, 2px 2px 0 ${textShadowColor}`,
              },
            }}>
            {bookTitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ImposedImage;
